// @ts-nocheck

import { Container } from "components/LandingPage/Container";

import cx from "classix";
import { Glow, GlowCapture } from "@codaworks/react-glow";
import {
  ChartBarIcon,
  CodeBracketSquareIcon,
  LockClosedIcon,
  Square2StackIcon,
} from "@heroicons/react/24/outline";

export function PrimaryFeatures() {
  return (
    <section id="features" className="py-20 sm:py-24 z-50 relative features">
      <Container className="max-w-7xl">
        <div className="flex justify-center">
          <h2 className="gradient-text font-bold text-4xl text-center">
            Everything you need to manage JSON data
          </h2>
        </div>

        <GlowCapture>
          <div className="mt-16 grid grid-cols-1 md:grid-cols-5 gap-y-4 md:gap-8">
            <FeatureCard
              className="col-span-3"
              title="RESTful API"
              description="Simple HTTP endpoints for all CRUD operations. Store, retrieve, update, and delete JSON data with standard REST methods. Integrate with any programming language or framework."
              icon={<CodeBracketSquareIcon />}
            />
            <FeatureCard
              className="col-span-2"
              title="Secure Storage"
              description="Private collections protected with API keys."
              icon={<LockClosedIcon />}
            />
          </div>
          <div className="mt-4 md:mt-8 grid grid-cols-1 md:grid-cols-5 gap-y-4 md:gap-8">
            <FeatureCard
              className="col-span-2"
              title="Version Control"
              description="Every change creates a new version automatically. Roll back to any previous state with one click. Never lose important data again * (limited to 10 version)"
              icon={<Square2StackIcon />}
            />
            <FeatureCard
              className="col-span-3"
              title="Real-time Analytics"
              description="Monitor your API usage with detailed analytics."
              icon={<ChartBarIcon />}
            />
          </div>
        </GlowCapture>
      </Container>
    </section>
  );
}

function FeatureCard({
  title,
  description,
  className,
  icon,
}: {
  title: string;
  description: string;
  className?: string;
  icon: React.ForwardRefExoticComponent<React.SVGProps<SVGSVGElement>>;
}) {
  return (
    <div
      className={cx(
        "border-[1px] border-[#5E5176] bg-[#C8C8C8]/5 rounded-[20px] w-full",
        className
      )}
    >
      <Glow className="">
        <div className="glow:text-glow/50 glow:bg-purple/10 px-16 py-12 h-full">
          <div className="flex gap-2 items-center">
            <div className="w-8 md:w-9 text-gray-300">{icon}</div>
            <span className="text-2xl md:text-4xl text-white font-medium">
              {title}
            </span>
          </div>
          <p className="text-[#C4C4C4] mt-4 h-full">{description}</p>
        </div>
      </Glow>
    </div>
  );
}
